module.exports = __webpack_public_path__ + "img/hr-straight-rail-diagonal-left-top-metals.aefe0b98.png";